export const IMPORT_FILE_STEP = 'IMPORT_FILE_STEP';
export const SHOW_PREVIEW_STEP = 'SHOW_PREVIEW_STEP';
export const IS_CREATED_STEP = 'IS_CREATED_STEP';
